import React from 'react';
import Input from 'es6/components/registration/inputs/input';
import { t } from 'es6/services/localization';

export default function CouponInput(props) {
  return (<Input type="text" name="coupon_code" placeholder={t('placeholder.coupon')} {...props} />);
}
